import { useLayoutEffect } from "react";
import ScrollSmoother from "gsap/ScrollSmoother";
import { prefersReducedMotion } from "../lib/gsap";

export function useScrollSmoother(enabled = true) {
  useLayoutEffect(() => {
    if (!enabled || prefersReducedMotion()) return undefined;

    const existing = ScrollSmoother.get();
    if (existing) return undefined;

    const smoother = ScrollSmoother.create({
      smooth: 1,
      effects: true,
      smoothTouch: 0.1,
      normalizeScroll: true,
    });

    return () => smoother.kill();
  }, [enabled]);
}
